import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import cx from 'classnames'

import ActionIcon from 'common/components/ActionIcon'
import Button from 'common/components/button/Button'
import Tooltip from 'common/components/Tooltip'
import { useAppSelector } from 'common/hooks/redux'
import { ArrowLeft, Menu as MenuIcon } from 'common/icons'
import useGetTemplateQuery from 'features/futurama/api/queries/useGetTemplateQuery'
import {
  hideWorkflow,
  showWorkflow,
} from 'features/futurama/store/contentSlice'

import { useContentOrTemplate } from '../../hooks'

import HeaderActions from './HeaderActions'

type Props = {
  hasMaxWidth?: boolean
}

const Header = ({ hasMaxWidth }: Props) => {
  const activeTemplateId = useAppSelector(
    (state) => state.content.activeTemplateId
  )
  const dispatch = useDispatch()

  const { content } = useContentOrTemplate()

  const { data: contentTemplate } = useGetTemplateQuery(content?.template_id)
  const { data: template } = useGetTemplateQuery(activeTemplateId)

  const contentTemplateDisplayName = contentTemplate?.display_name
  const templateDisplayName = template?.display_name
  const isWorkflowVisible = useAppSelector(
    (state) => state.content.isWorkflowVisible
  )
  const history = useHistory()

  return (
    <div className="flex flex-none items-center border-b-1 border-coolGray-200 h-14 py-2 px-6">
      <div
        className={cx(`flex-1 flex justify-between`, {
          'max-w-363 sm:mx-auto': !hasMaxWidth,
        })}
      >
        <div className="flex justify-center items-center">
          <ActionIcon onClick={() => history.push('/content')}>
            <ArrowLeft className="cursor-pointer" />
          </ActionIcon>
          <Button
            className="pr-1 md:hidden"
            prefixIcon={
              <Tooltip
                overlay={isWorkflowVisible ? 'Hide workflow' : 'Show workflow'}
              >
                <MenuIcon />
              </Tooltip>
            }
            onClick={() => {
              isWorkflowVisible
                ? dispatch(hideWorkflow())
                : dispatch(showWorkflow())
            }}
          />
          <span className="text-lg font-medium text-coolGray-800 md:ml-3">
            {contentTemplateDisplayName ?? templateDisplayName}
          </span>
        </div>

        <HeaderActions />
      </div>
    </div>
  )
}

export default Header
